<template>
  <div class="social_wrap">
    <div class="inon_erweima_code_icon">
      <div class="inon_erweima_code_icon_left">
        <div class="inon_erweima_code_icon_left_con"></div>
      </div>
      <div class="inon_erweima_code_icon_img">
        <img src="../assets/wmzs.png" />
      </div>
      <div class="inon_erweima_code_icon_right">
        <div class="inon_erweima_code_icon_left_con"></div>
      </div>
    </div>
    <div class="inon_qq_weixin_sso">
      <div class="icon_weixin">
        <el-button type="text" @click="centerDialogVisibles">
          <span>微信登录</span>
        </el-button>
        <el-dialog :visible.sync="centerDialogVisible" width="300px" center height="300px" @close="clost_dialog" :close-on-click-modal="false">
          <div class="social_title" :class="{'text_color_change':text_color_change}">{{code_text}}</div>
          <div class="img_wrap_img_maskin">
            <img :src="img_src" class="img_show_class" @load="loadImg" :class="{'img_autoheight':img_autoheight,'img_masking-out':masking_out}" />
            <img src="../assets/comfirm.png" class="img_margin_index" v-show="img_index_show" />
          </div>
        </el-dialog>
      </div>
      <div class="icon_qq" @click="centerDialogQQVisibles">
        <span>QQ登录</span>
      </div>
      <div class="icon_sso">
        <span>SSO登录</span>
      </div>
    </div>
  </div>
</template>
<script>
import Net_Work from "../apis/network.js";
import axios from "axios";
import { change_token } from "../apis/token.js";
import Qs from "qs";
axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;
export default {
  name: "social",
  data() {
    return {
      centerDialogVisible: false,
      img_src: "",
      text_color_change: false,
      img_down: "",
      code_text: "请使用微信扫码登录",
      img_autoheight: true,
      img_index_show: false,
      timer: "",
      number: 0,
      isDisable: true,
      option: "",
      masking_out: false
    };
  },
  methods: {
    centerDialogVisibles() {
      var _this = this;
      _this.img_src = "";
      _this.img_autoheight = true;
      this.centerDialogVisible = !this.centerDialogVisible;
      if (this.isDisable) {
        _this.isDisable = false;
        axios
          .get("/w/api/qr/get/temporary")
          .then(function(response) {
            if (0 === response.data.code) {
              _this.img_src = response.data.data.showUrl;
              _this.timer = setInterval(function() {
                _this.number++;
                if (_this.number > 60) {
                  _this.code_text = "二维码失效";
                  _this.number = 0;
                  _this.isDisable = true;
                  clearInterval(_this.timer);
                  _this.img_autoheight = true;
                  _this.text_color_change = true;
                }
                axios
                  .get("/w/api/qr/get/token?sceneId=" + response.data.sceneId)
                  .then(function(response) {
                    if (0 === response.data.code) {
                      _this.number = 0;
                      _this.isDisable = true;
                      clearInterval(_this.timer);
                      change_token(response.data);
                      _this.masking_out = true;
                      _this.img_index_show = true;
                      axios.defaults.headers.common["Authorization"] =
                        response.data.access_token;
                      axios
                        .get("s/api/main/user")
                        .then(function(response) {
                          if (response.data.code === 0) {
                            if (response.data.data.phone) {
                              /*如果手机号存在*/
                              location.replace(Net_Work.publicPhoneAddress);
                            } else {
                              _this.$router.push("/first-login");
                              _this.centerDialogVisible = false;
                              window.scrollTo(0, 0);
                            }
                          } else {
                            _this.$message.error("登录失败");
                          }
                        })
                        .catch(function(error) {});
                    }
                  })
                  .catch(function(error) {});
              }, 1000);
            }
          })
          .catch(function(error) {});
      }
    },
    loadImg() {
      this.img_autoheight = false;
    },
    clost_dialog() {
      clearInterval(this.timer);
      this.number = 0;
      this.text_color_change = false;
      this.code_text = "请使用微信扫码登录";
      this.masking_out = false;
      this.img_index_show = false;
      this.isDisable = true;
    },
    centerDialogQQVisibles() {
      var url =
        "https://graph.qq.com/oauth2.0/authorize?client_id=101911337&response_type=token&redirect_uri=" +
        encodeURIComponent("https://manager.dbclass.cn/callback/qq.html");
      window.location.href = url;
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.social_wrap {
  width: 100%;

  .text_color_change {
    color: red;
  }

  .img_masking-out {
    opacity: 0.3;
  }

  .img_wrap_img_maskin {
    position: relative;
  }

  .inon_erweima_code_icon {
    display: flex;
    margin-top: 20px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;

    .inon_erweima_code_icon_left {
      width: 100px;
      height: 20px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin-left: 50px;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;

      .inon_erweima_code_icon_left_con {
        height: 1px;
        background-color: #cccccc;
        width: 100px;
      }

      .inon_erweima_code_icon_img {
        width: 20px;
        height: 20px;

        img {
          display: block;
        }
      }
    }

    .inon_erweima_code_icon_right {
      width: 100px;
      margin-right: 50px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;

      .inon_erweima_code_icon_left_con {
        height: 1px;
        background-color: #cccccc;
        width: 100px;
      }
    }
  }

  .inon_qq_weixin_sso {
    display: flex;
    margin-top: 10px;
    justify-content: space-between;

    .icon_weixin,
    .icon_qq,
    .icon_sso {
      width: 100px;
      height: 30px;
      border: 1px solid #cccccc;
    }

    .icon_weixin {
      background: url(../assets/wechat.png) no-repeat 14px center;
      background-size: 14px 12px;

      span {
        display: block;
        font-size: 12px;
        line-height: 30px;
        margin-left: 40px;
        color: #222743;
        text-decoration: none;
        cursor: pointer;
      }

      img {
        display: block;
        width: 200px;
        height: 200px;
      }

      .img_margin_index {
        width: 48px;
        height: 48px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .img_autoheight {
        visibility: hidden;
      }
    }

    .icon_qq {
      background: url(../assets/qq.png) no-repeat 14px center;
      background-size: 10px 12px;

      span {
        display: block;
        font-size: 12px;
        line-height: 30px;
        margin-left: 40px;
        color: #222743;
        text-decoration: none;
        cursor: pointer;
      }
    }

    .icon_sso {
      background: url(../assets/sso_icon_little.png) no-repeat 14px center;
      background-size: 12px 12px;

      span {
        display: block;
        font-size: 12px;
        line-height: 30px;
        margin-left: 40px;
        color: #222743;
        text-decoration: none;
        cursor: no-drop;
      }
    }
  }
}
</style>
<style lang="less">
.icon_weixin {
  .el-button {
    padding: 0;
  }

  .el-dialog__body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .social_title {
    // text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/social.vue